import { Injectable } from '@angular/core';
import { Logentry } from './logentry.model';

@Injectable()
/*
 @whatItDoes: Logging on Client / delegates to Console, could be extended.
 */
export class ClientLoggerService {
  log(log: Logentry) {
    console[log.level](log.message, ...log.parameters);
  }
}
